<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin"></div>
        </Transition>

        <ConfirmDialog header="Confirm operation"
                       question="Do you want to get positions from SAP system?"
                       v-model="isConfirmationGetSapPositionsOpen"
                       :operation="actionGetSapPositionsButton" />

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :buttonsVisibility="buttonsVisibility"
                :rowButtonAction="rowButtonAction"
                v-model:selectedRows="selectedRows">
            <template #buttons="formProps">
                <div>
                    <Button @click.stop="openConfirmationGetSapPositionsWindow(formProps)"
                            style="background-color:lightsalmon;color:black;margin:0 7px 0 25px;white-space:nowrap"
                            severity="info">
                        <i class="fa-solid fa-users-viewfinder"
                           style="margin-right:5px;font-size:18px"></i>
                        {{ __('Get SAP positions') }}
                    </Button>
                </div>
            </template>

            <template #crud="formProps">
                <PositionForm :formProps="formProps">
                </PositionForm>
            </template>
            <template #search="searchProps">
                <PositionSearch :searchProps="searchProps">
                </PositionSearch>
            </template>
        </v-view>
    </div>

</template>

<script setup>
import { ref } from "vue";
import PositionForm from './PositionForm.vue'
import PositionSearch from './PositionSearch.vue'
import ConfirmDialog from '@pages/Crud/ConfirmDialog.vue'
import Button from 'primevue/button'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { __, getFromRoute, screenMessage, getTimeouts } from '@pages/Helper/utils.js'

const selectedRows = ref([])

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const isLoading = ref(false)
const isConfirmationGetSapPositionsOpen = ref(false)
const getLazyData = ref(false)

//------------------------------------------------------------------------------


const actionGetSapPositionsButton = async () => {
    isLoading.value = true
    const response = await getFromRoute('position-get-from-sap', {}, 'get')
    isLoading.value = false

    if (getLazyData.value) {
        getLazyData.value()
    }

    const timeouts = getTimeouts()
    if (response.status == 'success') {
        screenMessage({ message: response.message, title: "Information", type: "info", position: "center", timeout: timeouts.info });
    } else {
        screenMessage({ message: response.message, title: "Information", type: "error", position: "center", timeout: timeouts.error });
    }
}

//------------------------------------------------------------------------------

const openConfirmationGetSapPositionsWindow = (formProps) => {
    getLazyData.value = formProps.getLazyData
    isConfirmationGetSapPositionsOpen.value = true
}

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
